// https://developer.chrome.com/blog/autoplay/
export const ROOM_LIVE_VIEW_AUTOPLAY_POLICY_ENABLED_QUERY_PARAM_NAME =
  "room:live-view:autoplay-policy-enabled";
